export default {
    exact: '#F79498',
    selected: '#FFD485',
    others: '#8DD163',
    focus: '#AB8500',
    focused: '#FFF98A',
    common: '',
    query: '#ffd8a9',
    bioOthers: '#cae8ff'
};
